import { MessageType } from "winslow-core";

export type ExpectedDisposition = "ok" | "escalate";

export type AIReplayStep = {
    inputMessage: string;
    persona: string;
    expectedMessageType: MessageType;
    expectedDisposition: ExpectedDisposition;
    expectedMessageData: any;
}

export interface AIReplayScenario {
  name: string;
  scenario: string;
  steps: AIReplayStep[];
  attempts: number;
}


// for each type you can check the following outcomes:
//
// AI_MESSAGE_UI: check the object and label
// AI_MESSAGE_REPORTING: check the rows 
// AI_MESSAGE_DOCUMENT: check the match (text match of title, description, or url)
// AI_MESSAGE: check the contexts (persona names, employee names) and files (match of url or title)


export const aireplayScenarios: AIReplayScenario[] = [
    {
        name: "Smoke Test - Persona Changes",
        scenario: "smoke-persona-changes",
        steps: [
            {
                inputMessage: "Do we have monday off",
                persona: "Dalton Wais",
                expectedMessageType: MessageType.AI_MESSAGE_UI,
                expectedDisposition: "ok",
                expectedMessageData: {
                    object: "company-holidays",
                    label: "view"
                },
            },
            {
                inputMessage: "Do we have monday off again",
                persona: "Dalton Wais",
                expectedMessageType: MessageType.AI_MESSAGE_UI,
                expectedDisposition: "ok",
                expectedMessageData: {
                    object: "company-holidays",
                    label: "view"
                },
            },
            {
                inputMessage: "Do we have tuesday off",
                persona: "",
                expectedMessageType: MessageType.AI_MESSAGE_UI,
                expectedDisposition: "ok",
                expectedMessageData: {
                    object: "company-holidays",
                    label: "view"
                }
            },
            {
                inputMessage: "Do we have tuesday off again",
                persona: "",
                expectedMessageType: MessageType.AI_MESSAGE_UI,
                expectedDisposition: "ok",
                expectedMessageData: {
                    object: "company-holidays",
                    label: "view"
                }            
            },
            {
                inputMessage: "Do we have wednesday off",
                persona: "Niel Robertson",
                expectedMessageType: MessageType.AI_MESSAGE_UI,
                expectedDisposition: "ok",
                expectedMessageData: {
                    object: "company-holidays",
                    label: "view"
                },
            },
            {
                inputMessage: "Do we have wednesday off again",
                persona: "Niel Robertson",
                expectedMessageType: MessageType.AI_MESSAGE_UI,
                expectedDisposition: "ok",
                expectedMessageData: {
                    object: "company-holidays",
                    label: "view"
                },
            },
        ],
        attempts: 1,
    },
    {
        name: "Smoke Test - Demo",
        scenario: "smoke-demo",
        steps: [
            {
                inputMessage: "I want to take time off",
                persona: "",
                expectedMessageType: MessageType.AI_MESSAGE_UI,
                expectedDisposition: "ok",
                expectedMessageData: {
                    object: "pto-request",
                    label: "ptoRequest",
                },
            },
            {
                inputMessage: "Approve PTO for Dalton",
                persona: "",
                expectedMessageType: MessageType.AI_MESSAGE_UI,
                expectedDisposition: "ok",
                expectedMessageData: {
                    object: "pto-history",
                    label: "ptoHistory",
                },
            },
            {
                inputMessage: "run a report of all employees who live in colorado and started after Jan 1, 2024",
                persona: "",
                expectedMessageType: MessageType.AI_MESSAGE_REPORTING,
                expectedDisposition: "ok",
                expectedMessageData: {
                    rows: 1
                },
            },
            
        ],
        attempts: 3,
    },
    {
        name: "Smoke Test - Each Type",
        scenario: "smoke-types",
        steps: [
            {
                inputMessage: "run a report of all employees who live in colorado",
                persona: "",
                expectedMessageType: MessageType.AI_MESSAGE_REPORTING,
                expectedDisposition: "ok",
                expectedMessageData: {
                    rows: 1
                },
            },
            {
                inputMessage: "i want to take time off",
                persona: "",
                expectedMessageType: MessageType.AI_MESSAGE_UI,
                expectedDisposition: "ok",
                expectedMessageData: {
                    object: "pto-request",
                    label: "ptoRequest",
                },
            },
            {
                inputMessage: "what is our policy on paternity leave?",
                persona: "",
                expectedMessageType: MessageType.AI_MESSAGE,
                expectedDisposition: "ok",
                expectedMessageData: {}
            },
            {
                inputMessage: "find me the contractor agreement template",
                persona: "",
                expectedMessageType: MessageType.AI_MESSAGE_DOCUMENT,
                expectedDisposition: "ok",
                expectedMessageData: {
                    match: "contractor agreement template",
                }
            }
        ],
        attempts: 1,
    },
    {
        name: "Smoke Test - Escalation",
        scenario: "smoke-escalation",
        steps: [
            {
                inputMessage: "i was harassed by my boss, what do i do?",
                persona: "",
                expectedMessageType: MessageType.AI_MESSAGE,
                expectedDisposition: "escalate",
                expectedMessageData: {}
            }
        ],
        attempts: 1,
    },
    {
        name: "Smoke Test - Expect Failures",
        scenario: "smoke-expect-failure",
        steps: [
            {
                inputMessage: "i want to take time off",
                persona: "",
                expectedMessageType: MessageType.AI_MESSAGE_UI,
                expectedDisposition: "ok",
                expectedMessageData: {
                    object: "pto-request",
                    label: "XXX",
                }
            },
            {
                inputMessage: "i want to take time off",
                persona: "",
                expectedMessageType: MessageType.AI_MESSAGE_UI,
                expectedDisposition: "ok",
                expectedMessageData: {
                    object: "XXX",
                    label: "ptoRequest",
                }
            },
            {
                inputMessage: "i want to take time off",
                persona: "",
                expectedMessageType: MessageType.AI_MESSAGE,
                expectedDisposition: "ok",
                expectedMessageData: {}
            },
            {
                inputMessage: "i want to take time off",
                persona: "XXX",
                expectedMessageType: MessageType.AI_MESSAGE_UI,
                expectedDisposition: "ok",
                expectedMessageData: {
                    object: "pto-request",
                    label: "ptoRequest",
                }
            },
            {
                inputMessage: "i want to take time off",
                persona: "",
                expectedMessageType: MessageType.AI_MESSAGE_UI,
                expectedDisposition: "escalate",
                expectedMessageData: {
                    object: "pto-request",
                    label: "ptoRequest",
                }
            },
        ],
        attempts: 1,
    },
    {
        name: "Smoke Test - Multiple Attempts",
        scenario: "smoke-multiple-attempts",
        steps: [
            {
                inputMessage: "i want to take time off",
                persona: "",
                expectedMessageType: MessageType.AI_MESSAGE_UI,
                expectedDisposition: "ok",
                expectedMessageData: {
                    object: "pto-request",
                    label: "ptoRequest",
                }
            }
        ],
        attempts: 3,
    },
    {
        name: "Smoke Test - Personas",
        scenario: "smoke-personas",
        steps: [
            {
                inputMessage: "what are my healthcare deductible costs",
                persona: "Dalton Wais",
                expectedMessageType: MessageType.AI_MESSAGE,
                expectedDisposition: "ok",
                expectedMessageData: {}
            },
            {
                inputMessage: "what are my healthcare deductible costs",
                persona: "Niel Robertson",
                expectedMessageType: MessageType.AI_MESSAGE,
                expectedDisposition: "ok",
                expectedMessageData: {}
            },
            {
                inputMessage: "what are my healthcare deductible costs",
                persona: "",
                expectedMessageType: MessageType.AI_MESSAGE,
                expectedDisposition: "ok",
                expectedMessageData: {}
            },
            {
                inputMessage: "what are my healthcare deductible costs",
                persona: "XXX",
                expectedMessageType: MessageType.AI_MESSAGE,
                expectedDisposition: "ok",
                expectedMessageData: {}
            }
        ],
        attempts: 1,
    },
    {
        name: "Smoke Test - Bad Persona Employee",
        scenario: "smoke-bad-persona-employee",
        steps: [
            {
                inputMessage: "what are my healthcare deductible costs",
                persona: "XXX",
                expectedMessageType: MessageType.AI_MESSAGE,
                expectedDisposition: "ok",
                expectedMessageData: {}
            }
        ],
        attempts: 1,
    },
];

